import { InjectionToken } from "@angular/core";
import { FormGroup } from "@angular/forms";

export const GRID_ADVANCE_FILTERS_FORM = new InjectionToken<FormGroup>('GRID_ADVANCE_FILTERS_FORM');
